import { render, staticRenderFns } from "./CoachingSurvey.vue?vue&type=template&id=0b45c078&"
import script from "./CoachingSurvey.vue?vue&type=script&lang=js&"
export * from "./CoachingSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports